const i18n = {
  registerHeader: {
    1: "Регистрация администратором системы",
    0: "Рэгістрацыя адміністратарам сістэмы",
  },
  isExternalAdmin : {
    1: "Внешний администратор",
    0: "Знешні адміністратар"
  },
  isCallCenter : {
    1: "Cотрудник call-центра",
    0: "Cупрацоўнік call-цэнтра"
  },
  userRole: {
    1: "Роль пользователя",
    0: "Роля карыстальніка",
  },
  userType: {
    1: "Тип пользователя",
    0: "Тып карыстальніка",
  },
  userNameMessage: {
    1: "Проверьте корректность введенных данных. Поле заполняется латинскими символами и цифрами без пробелов.",
    0: "Праверце карэктнасць уведзеных дадзеных. Поле запаўняецца лацінскімі сімваламі і лічбамі без прабелаў.",
  },
  NameMessage: {
    1: "Проверьте корректность введенных данных. Поле заполняется кириллицей без пробелов.",
    0: "Праверце карэктнасць уведзеных дадзеных. Поле запаўняецца кірыліцай без прабелаў."
  },
  userNameLength: {
    1: "Длина поля 2-32 символов.",
    0: "Даўжыня поля 2-32 знакаў.",
  },
  passwordMessage: {
    1: "Пароль должен содержать минимум 8 символов, содержать латинские символы в верхнем и нижнем регистре, а также минимум один цифровой символ.",
    0: "Пароль павінен змяшчаць мінімум 8 сімвалаў, утрымліваць лацінскія сімвалы ў верхнім і ніжнім рэгістры, а таксама мінімум адзін лічбавы сімвал.",
  },
  confirmPassword: {
    1: "Подтверждение пароля",
    0: "Пацверджанне пароля",
  },
  passwordEquals: {
    1: "Пароли должны совпадать.",
    0: "Паролі павінны супадаць.",
  },
  register: {
    1: "Зарегистрировать",
    0: "Зарэгістраваць",
  },
  phoneNumberRegister: {
    1: "Номер телефона, указанный при регистрации",
    0: "Нумар тэлефона, пазначаны пры рэгістрацыі",
  },
  requiredField: {
    1: "Поле '${label}' обязательно для заполнения.",
    0: "Поле '${label}' абавязкова для запаўнення.",
  },
  confirmPasswordRequired: {
    1: "Поле 'Подтверждение пароля' обязательно для заполнения.",
    0: "Поле 'Пацверджанне пароля' абавязкова для запаўнення.",
  },
  incorrectEmail: {
    1: "Поле 'Email' заполненно некорректно.",
    0: "Поле 'Email' запоўнена некарэктна.",
  },
  isAddRoles: {
    1: "Назначить все роли",
    0: "Прызначыць усе ролі",
  }
};

export default i18n;
